import type {
  EditableFooterDispatchProps,
  EditableFooterStateProps,
} from 'components/shared/ScheduledRun/Blotter/panel/Shared/EditableFooter';
import {
  EditableFooter,
  editableFooterMapDispatchToProps,
  editableFooterMapStateToProps,
} from 'components/shared/ScheduledRun/Blotter/panel/Shared/EditableFooter';
import { connect, type MapStateToProps } from 'react-redux';
import { EDITABLE_SCHEDULED_RUN_BLOTTER_ID, getEditableScheduledRun } from 'state/blotters/scheduledQuotes';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import { hasChanged } from 'state/scheduledRuns/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

const mapStateToProps: MapStateToProps<EditableFooterStateProps, {}, AppState> = state => {
  return {
    ...editableFooterMapStateToProps(state),
    isEditing: getEditableScheduledRun(state).type === 'editSchedule',
    hasChanged: hasChanged(state, EDITABLE_SCHEDULED_RUN_BLOTTER_ID),
  };
};
const mapDispatchToProps = (dispatch: ThunkDispatch): EditableFooterDispatchProps => ({
  ...editableFooterMapDispatchToProps(dispatch),
  onEditClicked() {
    dispatch(scheduledRunActions.setOperation(EDITABLE_SCHEDULED_RUN_BLOTTER_ID, 'editSchedule'));
  },
  onConfirmUpdate() {
    dispatch(scheduledRunActions.updateScheduleRequested(EDITABLE_SCHEDULED_RUN_BLOTTER_ID));
    dispatch(scheduledRunActions.setConfirmBanner(EDITABLE_SCHEDULED_RUN_BLOTTER_ID, 'update'));
  },
});

const ConnectedSchedulesFooter = connect(mapStateToProps, mapDispatchToProps)(EditableFooter);
export function SchedulesFooter() {
  return (
    <ConnectedSchedulesFooter
      editBtnIcn="tune"
      editBtnLabel="scheduledRun.schedule.adjust"
      confirmMessageLabel="scheduledRun.schedule.confirm"
      errorLabel="scheduledRun.schedule.update.error"
      analyticAction="Adjust schedule"
    />
  );
}
